import { DataBean } from "../DataBean";

export class AuxLiquidation extends DataBean {


    public async getAuxLiquidationCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getAuxLiquidationCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }
   

    

 
}